import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getAllActors, getPublicActors } from '../../services/apiService';
import AuthContext from '../../store/auth-context';
import { filterAssignableRoles, getActorDisplayName } from '../../utils/roleUtils';
import styles from './Selectors.module.css';

const RoleSelector = ({
    id,
    onChange,
    defaultValue,
    handleInputFocus,
    handleInputBlur,
    isSignup = false,
}) => {
    const { t } = useTranslation();
    const context = useContext(AuthContext);

    const [actors, setActors] = useState([]);

    const getActors = async () => {
        if (isSignup) {
            const acts = await getPublicActors();
            setActors(acts);
        } else {
            const acts = await getAllActors();
            setActors(filterAssignableRoles(acts, context));
        }
    };

    useEffect(() => {
        getActors();
    }, []);

    return (
        <React.Fragment>
            {actors?.length > 0 && (
                <select
                    required
                    name="role"
                    id={id}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                    className={styles.select}
                >
                    {defaultValue === 'default' && (
                        <option
                            value="default"
                            className="role-placeholder"
                            disabled
                        >
                            {t('manageUser.roleSelector.placeholder')}
                        </option>
                    )}
                    {actors.map((a) => (
                        <option key={a._id} value={a.role}>
                            {getActorDisplayName(a)}
                        </option>
                    ))}
                </select>
            )}
        </React.Fragment>
    );
};

export default RoleSelector;
